import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "keyword-search" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "page-title" }, "키워드 검색"),
  /*#__PURE__*/_createElementVNode("p", { class: "page-desc" }, [
    /*#__PURE__*/_createTextVNode(" 키워드 하나를 넣으면 기본정보·트렌드·성향·연관 키워드를 탭으로 나눠 봅니다. "),
    /*#__PURE__*/_createElementVNode("strong", null, "포화도가 낮을수록"),
    /*#__PURE__*/_createTextVNode(" 경쟁 대비 노출에 유리합니다. ")
  ])
], -1)
const _hoisted_3 = {
  key: 0,
  class: "result-head"
}
const _hoisted_4 = { class: "rh-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "rh-label" }, "분석 결과", -1)
const _hoisted_6 = { class: "rh-keyword" }
const _hoisted_7 = { class: "rh-right" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "notice notice-warn"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "다시 찾기", -1)
const _hoisted_11 = {
  key: 2,
  class: "search-card"
}
const _hoisted_12 = { class: "seed-row" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "filter-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "최소 검색량", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "최대 검색량", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "분석 개수", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("em", { class: "hint" }, "발행량을 조회할 상위 N개 (최대 40)", -1)
const _hoisted_19 = {
  key: 3,
  class: "history-bar"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "hb-label" }, "최근 조회", -1)
const _hoisted_21 = { class: "hb-list" }
const _hoisted_22 = ["title", "onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 4,
  class: "notice notice-error"
}
const _hoisted_25 = { class: "tab-bar" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_28 = {
  key: 1,
  class: "tab-spin"
}
const _hoisted_29 = { class: "tab-panel" }
const _hoisted_30 = {
  key: 0,
  class: "skeleton-card"
}
const _hoisted_31 = {
  key: 0,
  class: "notice notice-warn"
}
const _hoisted_32 = { class: "verdict-title" }
const _hoisted_33 = { class: "verdict-desc" }
const _hoisted_34 = { class: "metric-grid" }
const _hoisted_35 = { class: "metric" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "metric-label" }, "월간 검색량", -1)
const _hoisted_37 = { class: "metric-value" }
const _hoisted_38 = { class: "metric-sub" }
const _hoisted_39 = { class: "metric" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "metric-label" }, "월간 발행량", -1)
const _hoisted_41 = { class: "metric-value" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "metric-sub" }, "블로그 문서 수", -1)
const _hoisted_43 = { class: "metric" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "metric-label" }, "포화 지수", -1)
const _hoisted_45 = { class: "metric-sub" }
const _hoisted_46 = { class: "metric" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "metric-label" }, "경쟁정도", -1)
const _hoisted_48 = { class: "metric-value sm" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "metric-sub" }, "네이버 광고 기준", -1)
const _hoisted_50 = { class: "detail-card" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "dc-title" }, "기기 분포", -1)
const _hoisted_52 = { class: "device-bar" }
const _hoisted_53 = { class: "dc-rows" }
const _hoisted_54 = { class: "dc-note" }
const _hoisted_55 = { class: "detail-card" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "dc-title" }, "광고·클릭 지표", -1)
const _hoisted_57 = { class: "dc-rows three" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", null, "모바일 클릭률", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", null, "월평균 클릭수", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", null, "광고 밀도", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", null, "1위 입찰가", -1)
const _hoisted_62 = { class: "dc-note" }
const _hoisted_63 = { class: "tab-panel" }
const _hoisted_64 = {
  key: 0,
  class: "skeleton-card"
}
const _hoisted_65 = {
  key: 1,
  class: "notice notice-warn"
}
const _hoisted_66 = { class: "unit-toggle" }
const _hoisted_67 = ["disabled", "onClick"]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "ut-note" }, "네이버는 일·주·월 단위만 제공합니다 (시간 단위 없음)", -1)
const _hoisted_69 = { class: "summary-row" }
const _hoisted_70 = { class: "sum-item" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", null, "최고", -1)
const _hoisted_72 = { class: "sum-item" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", null, "최저", -1)
const _hoisted_74 = { class: "sum-item" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", null, "최근 흐름", -1)
const _hoisted_76 = {
  key: 0,
  class: "notice notice-warn"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("b", null, "지금 급등 중입니다", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("b", null, "월간 검색량 숫자 자체도 이 급등이 끌어올린 값", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("b", null, "언제 튀었는지", -1)
const _hoisted_80 = {
  key: 1,
  class: "notice notice-muted"
}
const _hoisted_81 = /*#__PURE__*/_createElementVNode("b", null, "아직 진행 중", -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("b", null, "최근 흐름은 한 구간치로 환산해", -1)
const _hoisted_83 = { class: "chart-card" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("p", { class: "chart-note" }, [
  /*#__PURE__*/_createTextVNode(" 데이터랩 기준 "),
  /*#__PURE__*/_createElementVNode("b", null, "상대비율"),
  /*#__PURE__*/_createTextVNode("입니다(구간 최고점 = 100). 절대 검색량이 아닙니다. ")
], -1)
const _hoisted_85 = { class: "chart-area" }
const _hoisted_86 = { class: "detail-card" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "dc-title" }, "구간별 수치", -1)
const _hoisted_88 = { class: "mg-label" }
const _hoisted_89 = { class: "mg-value" }
const _hoisted_90 = { class: "dc-note" }
const _hoisted_91 = {
  key: 3,
  class: "empty-state"
}
const _hoisted_92 = { class: "tab-panel" }
const _hoisted_93 = {
  key: 0,
  class: "skeleton-card"
}
const _hoisted_94 = {
  key: 1,
  class: "notice notice-warn"
}
const _hoisted_95 = {
  key: 0,
  class: "weekday-card"
}
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "wc-title" }, "요일별 검색 비율", -1)
const _hoisted_97 = { class: "wc-bars" }
const _hoisted_98 = { class: "wc-track" }
const _hoisted_99 = { class: "wc-value" }
const _hoisted_100 = { class: "summary-row tight" }
const _hoisted_101 = { class: "sum-item" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", null, "가장 많이 찾는 날", -1)
const _hoisted_103 = { class: "sum-item" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", null, "가장 적은 날", -1)
const _hoisted_105 = { class: "sum-item" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("span", null, "주말 vs 주중", -1)
const _hoisted_107 = { class: "wc-note" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("b", null, "요일끼리 비교가 유효", -1)
const _hoisted_109 = { class: "segment-card" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "wc-title" }, "성별 · 연령대 추이", -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("p", { class: "wc-note warn" }, [
  /*#__PURE__*/_createTextVNode(" ⚠️ 네이버가 "),
  /*#__PURE__*/_createElementVNode("b", null, "세그먼트마다 자기 최고점을 100으로"),
  /*#__PURE__*/_createTextVNode(" 정규화해서 주기 때문에 \"남성이 여성보다 많다\" 같은 "),
  /*#__PURE__*/_createElementVNode("b", null, "크기 비교는 할 수 없습니다."),
  /*#__PURE__*/_createTextVNode(" 언제 오르내리는지 "),
  /*#__PURE__*/_createElementVNode("b", null, "추이 모양"),
  /*#__PURE__*/_createTextVNode("만 비교하세요. ")
], -1)
const _hoisted_112 = { class: "chart-area sm" }
const _hoisted_113 = {
  key: 1,
  class: "chart-skeleton"
}
const _hoisted_114 = { class: "tab-panel" }
const _hoisted_115 = {
  key: 0,
  class: "loading-panel"
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "lp-bar" }, [
  /*#__PURE__*/_createElementVNode("i")
], -1)
const _hoisted_117 = { class: "lp-stage" }
const _hoisted_118 = { class: "lp-meta" }
const _hoisted_119 = { class: "lp-elapsed" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("span", { class: "lp-hint" }, "보통 15~25초 걸립니다", -1)
const _hoisted_121 = { class: "lp-steps" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("p", { class: "lp-note" }, [
  /*#__PURE__*/_createTextVNode(" 네이버 호출 제한 때문에 발행량은 "),
  /*#__PURE__*/_createElementVNode("b", null, "한 건씩 순차로"),
  /*#__PURE__*/_createTextVNode(" 조회합니다. 한 번 조회한 키워드는 하루 동안 기억해 두므로 다시 찾을 때는 빠릅니다. ")
], -1)
const _hoisted_123 = { class: "scope-bar" }
const _hoisted_124 = ["disabled", "onClick"]
const _hoisted_125 = { class: "result-summary" }
const _hoisted_126 = { class: "chip" }
const _hoisted_127 = { class: "chip" }
const _hoisted_128 = {
  key: 0,
  class: "chip good"
}
const _hoisted_129 = { class: "notice notice-muted" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("b", null, "전체", -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("b", null, "뜻이 비슷한 말", -1)
const _hoisted_132 = /*#__PURE__*/_createElementVNode("b", null, "같은 광고주가 함께 사는 키워드", -1)
const _hoisted_133 = /*#__PURE__*/_createElementVNode("b", null, "씨앗 포함", -1)
const _hoisted_134 = {
  key: 0,
  class: "notice notice-warn"
}
const _hoisted_135 = {
  key: 1,
  class: "notice notice-warn"
}
const _hoisted_136 = { class: "table-scroll" }
const _hoisted_137 = { class: "keyword-table" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("th", { class: "col-kw" }, "키워드", -1)
const _hoisted_139 = { key: 0 }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("th", { class: "col-num col-device" }, "PC", -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("th", { class: "col-num col-device" }, "모바일", -1)
const _hoisted_142 = { key: 0 }
const _hoisted_143 = { key: 0 }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("th", { class: "col-comp" }, "경쟁", -1)
const _hoisted_145 = { class: "col-kw" }
const _hoisted_146 = ["onClick"]
const _hoisted_147 = {
  key: 0,
  class: "rel-dot",
  title: "씨앗을 그대로 품은 키워드"
}
const _hoisted_148 = { class: "col-num strong" }
const _hoisted_149 = { class: "col-num dim col-device" }
const _hoisted_150 = { class: "col-num dim col-device" }
const _hoisted_151 = { class: "col-num" }
const _hoisted_152 = { class: "col-num" }
const _hoisted_153 = { key: 0 }
const _hoisted_154 = { class: "col-comp" }
const _hoisted_155 = { key: 0 }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "7",
  class: "empty"
}, "조건에 맞는 키워드가 없습니다.", -1)
const _hoisted_157 = [
  _hoisted_156
]
const _hoisted_158 = { class: "table-note" }
const _hoisted_159 = { class: "legend" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("i", { class: "dot good" }, null, -1)
const _hoisted_161 = { class: "legend" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("i", { class: "dot mid" }, null, -1)
const _hoisted_163 = { class: "legend" }
const _hoisted_164 = /*#__PURE__*/_createElementVNode("i", { class: "dot bad" }, null, -1)
const _hoisted_165 = { class: "tab-panel" }
const _hoisted_166 = {
  key: 0,
  class: "skeleton-card"
}
const _hoisted_167 = /*#__PURE__*/_createElementVNode("div", { class: "notice notice-muted" }, [
  /*#__PURE__*/_createElementVNode("b", null, "최근 발행된 네이버 블로그 글"),
  /*#__PURE__*/_createTextVNode("입니다(최신순). 상위 노출 순위가 아닙니다. 네이버는 "),
  /*#__PURE__*/_createElementVNode("b", null, "검색 결과 순위를 주는 공식 API가 없고"),
  /*#__PURE__*/_createTextVNode(", 크롤링은 하지 않는다는 원칙이라 순위를 재현할 방법이 없습니다. 대신 "),
  /*#__PURE__*/_createElementVNode("b", null, "경쟁 글이 얼마나 자주 올라오는지"),
  /*#__PURE__*/_createTextVNode(", 어떤 제목으로 쓰는지 보는 용도로 쓰세요. ")
], -1)
const _hoisted_168 = { class: "blog-list" }
const _hoisted_169 = { class: "bl-no" }
const _hoisted_170 = { class: "bl-body" }
const _hoisted_171 = ["href"]
const _hoisted_172 = { class: "bl-desc" }
const _hoisted_173 = { class: "bl-meta" }
const _hoisted_174 = { class: "bl-blogger" }
const _hoisted_175 = { class: "table-note" }
const _hoisted_176 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_177 = { class: "tab-panel" }
const _hoisted_178 = /*#__PURE__*/_createStaticVNode("<div class=\"detail-card\"><div class=\"dc-title\">각 숫자를 어떻게 읽나</div><dl class=\"guide-dl\"><dt>포화 지수 = 발행량 ÷ 검색량</dt><dd><b>1 미만</b> 글이 적어 노려볼 만함 · <b>1~5</b> 보통, 내용으로 승부 · <b>5 이상</b> 이미 포화. 이 서비스가 기본으로 포화도 낮은 순 정렬하는 이유입니다. </dd><dt>모바일 클릭률</dt><dd>검색은 많은데 이 값이 낮으면 <b>검색 결과만 보고 이탈</b>하는 키워드입니다. 글을 써도 유입이 적습니다.</dd><dt>광고 밀도</dt><dd>높을수록 검색 결과 위쪽을 광고가 차지해 <b>자연검색 자리가 밀립니다.</b></dd><dt>1위 입찰가</dt><dd>광고비를 내고서라도 데려갈 만한 키워드인지 = <b>상업적 가치</b>입니다. 수익형 글감을 고를 때 봅니다.</dd><dt>트렌드 · 성향의 상대비율</dt><dd> 데이터랩은 <b>구간 최고점을 100으로</b> 맞춰 줍니다. 절대 검색량이 아닙니다. 특히 성별·연령은 세그먼트마다 따로 정규화돼 <b>서로 크기 비교가 불가능</b>합니다(모양만 비교). </dd></dl></div><div class=\"detail-card\"><div class=\"dc-title\">이 서비스가 제공하지 못하는 것</div><dl class=\"guide-dl\"><dt>검색 결과 상위 노출 순위</dt><dd>공식 API가 없습니다. 크롤링으로 우회하지 않는다는 원칙이라 제공하지 않습니다.</dd><dt>스마트블록 · 섹션 배치</dt><dd>위와 같은 이유로 불가능합니다.</dd><dt>실시간 인기 검색어</dt><dd> 네이버는 2021년 폐지 후 부활 계획이 없습니다. (다음은 2026년 3월 부활 · 네이트 제공 중 · 구글 트렌드는 연예·스포츠 위주) 데이터랩 인기검색어 TOP500 도 웹 화면 전용이라 API로 받을 수 없습니다. 대신 <b>인기 키워드</b> 메뉴에서 검색광고 데이터로 만든 대체 랭킹을 제공합니다. </dd></dl></div>", 2)
const _hoisted_180 = [
  _hoisted_178
]
const _hoisted_181 = {
  key: 6,
  class: "empty-state"
}
const _hoisted_182 = /*#__PURE__*/_createElementVNode("b", null, "찾기", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Line = _resolveComponent("Line")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.searchedKeyword)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.searchedKeyword), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.seed) = $event)),
              class: "rh-input",
              type: "text",
              placeholder: "다른 키워드",
              maxlength: "100",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.doSearch && _ctx.doSearch(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.form.seed]
            ]),
            _createElementVNode("button", {
              class: "btn-search sm",
              disabled: _ctx.anyLoading,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.doSearch && _ctx.doSearch(...args)))
            }, _toDisplayString(_ctx.anyLoading ? "조회 중…" : "다시 찾기"), 9, _hoisted_8)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.searchedKeyword && _ctx.isDirty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createTextVNode(" 입력한 "),
          _createElementVNode("b", null, "「" + _toDisplayString(_ctx.form.seed.trim()) + "」", 1),
          _createTextVNode("는 아직 조회하지 않았습니다. 아래 결과는 여전히 "),
          _createElementVNode("b", null, "「" + _toDisplayString(_ctx.searchedKeyword) + "」", 1),
          _createTextVNode("의 분석입니다 — "),
          _hoisted_10,
          _createTextVNode("를 눌러 주세요. ")
        ]))
      : _createCommentVNode("", true),
    (!_ctx.searchedKeyword)
      ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.seed) = $event)),
              class: "seed-input",
              type: "text",
              placeholder: "예: 여의도맛집",
              maxlength: "100",
              onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.doSearch && _ctx.doSearch(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.form.seed]
            ]),
            _createElementVNode("button", {
              class: "btn-search",
              disabled: _ctx.anyLoading,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.doSearch && _ctx.doSearch(...args)))
            }, _toDisplayString(_ctx.anyLoading ? "조회 중…" : "찾기"), 9, _hoisted_13)
          ]),
          _createElementVNode("button", {
            class: "btn-toggle-filter",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filterOpen = !_ctx.filterOpen))
          }, _toDisplayString(_ctx.filterOpen ? "상세 조건 접기" : "상세 조건"), 1),
          _withDirectives(_createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", null, [
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.minVolume) = $event)),
                type: "number",
                min: "0",
                placeholder: "예: 100"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.minVolume,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", null, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.maxVolume) = $event)),
                type: "number",
                min: "0",
                placeholder: "예: 50000"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.maxVolume,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", null, [
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.limit) = $event)),
                type: "number",
                min: "1",
                max: "40",
                placeholder: "40"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.limit,
                  void 0,
                  { number: true }
                ]
              ]),
              _hoisted_18
            ])
          ], 512), [
            [_vShow, _ctx.filterOpen]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.history.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (h) => {
              return (_openBlock(), _createElementBlock("span", {
                key: h.id,
                class: _normalizeClass(["hb-item", { active: h.id === _ctx.activeHistoryId, pending: h.pending }])
              }, [
                _createElementVNode("button", {
                  class: "hb-open",
                  title: h.pending ? '조회가 아직 끝나지 않았습니다' : _ctx.rel(h.at) + ' 조회',
                  onClick: ($event: any) => (_ctx.restore(h.id))
                }, [
                  _createTextVNode(_toDisplayString(h.seed), 1),
                  _createElementVNode("em", null, _toDisplayString(h.pending ? "조회 중…" : _ctx.rel(h.at)), 1)
                ], 8, _hoisted_22),
                _createElementVNode("button", {
                  class: "hb-del",
                  title: "이 이력과 결과를 지웁니다",
                  onClick: ($event: any) => (_ctx.dropHistory(h.id))
                }, "✕", 8, _hoisted_23)
              ], 2))
            }), 128))
          ]),
          _createElementVNode("button", {
            class: "hb-clear",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clearHistory && _ctx.clearHistory(...args)))
          }, "전체 삭제")
        ]))
      : _createCommentVNode("", true),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    (_ctx.profile || _ctx.profileLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
          _createElementVNode("nav", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (t) => {
              return (_openBlock(), _createElementBlock("button", {
                key: t.key,
                class: _normalizeClass(["tab", { active: _ctx.activeTab === t.key }]),
                onClick: ($event: any) => (_ctx.activeTab = t.key)
              }, [
                _createTextVNode(_toDisplayString(t.label) + " ", 1),
                (t.badge)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(t.badge), 1))
                  : (t.key === 'related' && _ctx.relatedLoading)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_28))
                    : _createCommentVNode("", true)
              ], 10, _hoisted_26))
            }), 128))
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_29, [
            (_ctx.profileLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, "기본정보 불러오는 중…"))
              : (_ctx.profile)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.profile.notice)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.profile.notice), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["verdict", _ctx.verdict.tone])
                    }, [
                      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.verdict.title), 1),
                      _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.verdict.desc), 1)
                    ], 2),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.profile.totalVolume.toLocaleString()), 1),
                        _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.volumeGrade), 1)
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.fmt(_ctx.profile.docCount)), 1),
                        _hoisted_42
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createElementVNode("div", {
                          class: _normalizeClass(["metric-value", _ctx.saturationClass(_ctx.profile.saturation)])
                        }, _toDisplayString(_ctx.profile.saturation === null ? "-" : _ctx.profile.saturation.toFixed(2)), 3),
                        _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.saturationText), 1)
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.profile.competition || "-"), 1),
                        _hoisted_49
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", {
                          class: "db-pc",
                          style: _normalizeStyle({ width: (100 - (_ctx.profile.mobileShare || 0)) + '%' })
                        }, [
                          ((100 - (_ctx.profile.mobileShare || 0)) >= 12)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" PC " + _toDisplayString(100 - (_ctx.profile.mobileShare || 0)) + "% ", 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 4),
                        _createElementVNode("div", {
                          class: "db-mo",
                          style: _normalizeStyle({ width: (_ctx.profile.mobileShare || 0) + '%' })
                        }, [
                          ((_ctx.profile.mobileShare || 0) >= 12)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" 모바일 " + _toDisplayString(_ctx.profile.mobileShare || 0) + "% ", 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 4)
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", null, "PC 검색량 (" + _toDisplayString(100 - (_ctx.profile.mobileShare || 0)) + "%)", 1),
                          _createElementVNode("b", null, _toDisplayString(_ctx.profile.pcVolume.toLocaleString()), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("span", null, "모바일 검색량 (" + _toDisplayString(_ctx.profile.mobileShare || 0) + "%)", 1),
                          _createElementVNode("b", null, _toDisplayString(_ctx.profile.mobileVolume.toLocaleString()), 1)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.deviceAdvice), 1)
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", null, [
                          _hoisted_58,
                          _createElementVNode("b", null, _toDisplayString(_ctx.profile.mobileCtr === null ? "-" : _ctx.profile.mobileCtr.toFixed(2) + "%"), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_59,
                          _createElementVNode("b", null, _toDisplayString(_ctx.fmt(_ctx.profile.totalClicks)), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_60,
                          _createElementVNode("b", null, _toDisplayString(_ctx.profile.adDepth === null ? "-" : _ctx.profile.adDepth.toFixed(1)), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_61,
                          _createElementVNode("b", null, _toDisplayString(_ctx.profile.firstPositionBid === null ? "-" : _ctx.profile.firstPositionBid.toLocaleString() + "원"), 1)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.commercialAdvice), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.activeTab === 'basic']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_63, [
            (!_ctx.profile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_64, "불러오는 중…"))
              : (!_ctx.profile.datalabAvailable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.profile.datalabMessage || "검색 트렌드를 사용할 수 없습니다."), 1))
                : (_ctx.chartData)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_66, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.units, (u) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: u.key,
                            class: _normalizeClass(["ut-btn", { active: _ctx.trendUnit === u.key }]),
                            disabled: _ctx.trendLoading,
                            onClick: ($event: any) => (_ctx.changeUnit(u.key))
                          }, _toDisplayString(u.label), 11, _hoisted_67))
                        }), 128)),
                        _hoisted_68
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _hoisted_71,
                          _createElementVNode("b", null, _toDisplayString(_ctx.trendSummary.maxLabel), 1)
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _hoisted_73,
                          _createElementVNode("b", null, _toDisplayString(_ctx.trendSummary.minLabel), 1)
                        ]),
                        _createElementVNode("div", _hoisted_74, [
                          _hoisted_75,
                          _createElementVNode("b", {
                            class: _normalizeClass(_ctx.trendSummary.dirClass)
                          }, _toDisplayString(_ctx.trendSummary.direction), 3)
                        ])
                      ]),
                      (_ctx.trendSummary.surge)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                            _hoisted_77,
                            _createTextVNode(" — 진행 중인 구간을 한 구간치로 환산하면 직전 3구간 평균의 "),
                            _createElementVNode("b", null, _toDisplayString(_ctx.trendSummary.changeText), 1),
                            _createTextVNode("입니다. 방송·이슈로 갑자기 튄 것일 수 있습니다. "),
                            _hoisted_78,
                            _createTextVNode("이라, 며칠 뒤면 원래대로 내려갈 수 있습니다. 일별 탭에서 "),
                            _hoisted_79,
                            _createTextVNode(" 확인해 보세요 — 하루만 튀었다면 짧게 소비되는 주제입니다. ")
                          ]))
                        : (_ctx.trendSummary.hasPartial)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                              _createTextVNode(" 마지막 구간(" + _toDisplayString(_ctx.trendSummary.partialLabel) + ")은 ", 1),
                              _hoisted_81,
                              _createTextVNode("이라 막대가 낮게 보입니다. 최고·최저에서는 제외했고, "),
                              _hoisted_82,
                              _createTextVNode(" 비교했습니다. ")
                            ]))
                          : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_83, [
                        _hoisted_84,
                        _createElementVNode("div", _hoisted_85, [
                          _createVNode(_component_Line, {
                            data: _ctx.chartData,
                            options: _ctx.chartOptions,
                            class: "chart"
                          }, null, 8, ["data", "options"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_86, [
                        _hoisted_87,
                        _createElementVNode("div", {
                          class: _normalizeClass(["month-grid", { dense: _ctx.trendUnit !== 'month' }])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trendPoints, (p, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: p.period,
                              class: _normalizeClass(["mg-item", { peak: p.ratio === _ctx.trendSummary.max, partial: _ctx.trendSummary.hasPartial && i === _ctx.trendPoints.length - 1 }])
                            }, [
                              _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.periodLabel(p.period)), 1),
                              _createElementVNode("div", _hoisted_89, _toDisplayString(p.ratio.toFixed(0)), 1)
                            ], 2))
                          }), 128))
                        ], 2),
                        _createElementVNode("p", _hoisted_90, _toDisplayString(_ctx.trendSummary.advice), 1)
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_91, "추이 데이터가 없습니다."))
          ], 512), [
            [_vShow, _ctx.activeTab === 'trend']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_92, [
            (_ctx.insightLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_93, "성향·요일 분석 불러오는 중…"))
              : (_ctx.insight && !_ctx.insight.available)
                ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(_ctx.insight.message || "성향 분석을 사용할 수 없습니다."), 1))
                : (_ctx.insight)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_ctx.insight.weekday && _ctx.insight.weekday.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                            _hoisted_96,
                            _createElementVNode("div", _hoisted_97, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insight.weekday, (w) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: w.label,
                                  class: "wc-bar"
                                }, [
                                  _createElementVNode("div", _hoisted_98, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["wc-fill", { peak: w.peak }]),
                                      style: _normalizeStyle({ height: _ctx.barHeight(w.ratio) })
                                    }, null, 6)
                                  ]),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["wc-label", { peak: w.peak }])
                                  }, _toDisplayString(w.label), 3),
                                  _createElementVNode("div", _hoisted_99, _toDisplayString(w.ratio.toFixed(0)), 1)
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_100, [
                              _createElementVNode("div", _hoisted_101, [
                                _hoisted_102,
                                _createElementVNode("b", null, _toDisplayString(_ctx.weekdaySummary.peak), 1)
                              ]),
                              _createElementVNode("div", _hoisted_103, [
                                _hoisted_104,
                                _createElementVNode("b", null, _toDisplayString(_ctx.weekdaySummary.low), 1)
                              ]),
                              _createElementVNode("div", _hoisted_105, [
                                _hoisted_106,
                                _createElementVNode("b", null, _toDisplayString(_ctx.weekdaySummary.weekend), 1)
                              ])
                            ]),
                            _createElementVNode("p", _hoisted_107, [
                              _createTextVNode(" 최근 8주 일별 데이터를 요일로 묶은 평균입니다. "),
                              _hoisted_108,
                              _createTextVNode("합니다 — " + _toDisplayString(_ctx.weekdaySummary.advice), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_109, [
                        _hoisted_110,
                        _hoisted_111,
                        _createElementVNode("div", _hoisted_112, [
                          (_ctx.segmentChart)
                            ? (_openBlock(), _createBlock(_component_Line, {
                                key: 0,
                                data: _ctx.segmentChart,
                                options: _ctx.segmentOptions,
                                class: "chart"
                              }, null, 8, ["data", "options"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_113, "세그먼트 데이터가 없습니다."))
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.activeTab === 'insight']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_114, [
            (_ctx.relatedLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                  _hoisted_116,
                  _createElementVNode("div", _hoisted_117, _toDisplayString(_ctx.loadingStage), 1),
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("span", _hoisted_119, _toDisplayString(_ctx.relatedElapsed) + "초 경과", 1),
                    _hoisted_120
                  ]),
                  _createElementVNode("ul", _hoisted_121, [
                    _createElementVNode("li", {
                      class: _normalizeClass({ done: _ctx.relatedElapsed >= 3, now: _ctx.relatedElapsed < 3 })
                    }, "연관 키워드 모으기", 2),
                    _createElementVNode("li", {
                      class: _normalizeClass({ done: _ctx.relatedElapsed >= 8, now: _ctx.relatedElapsed >= 3 && _ctx.relatedElapsed < 8 })
                    }, "후보 검색량 확인", 2),
                    _createElementVNode("li", {
                      class: _normalizeClass({ now: _ctx.relatedElapsed >= 8 })
                    }, "발행량 세기 (한 건씩)", 2)
                  ]),
                  _hoisted_122
                ]))
              : (_ctx.result)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_123, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scopes, (s) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: s.key,
                          class: _normalizeClass(["scope", { active: _ctx.scope === s.key, empty: s.count === 0 }]),
                          disabled: s.count === 0,
                          onClick: ($event: any) => (_ctx.scope = s.key)
                        }, [
                          _createTextVNode(_toDisplayString(s.label) + " ", 1),
                          _createElementVNode("b", null, _toDisplayString(s.count), 1)
                        ], 10, _hoisted_124))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_125, [
                      _createElementVNode("span", _hoisted_126, [
                        _createTextVNode("연관 "),
                        _createElementVNode("b", null, _toDisplayString(_ctx.result.totalRelated.toLocaleString()), 1)
                      ]),
                      _createElementVNode("span", _hoisted_127, [
                        _createTextVNode("분석 "),
                        _createElementVNode("b", null, _toDisplayString(_ctx.result.analyzed.toLocaleString()), 1)
                      ]),
                      (_ctx.satBuckets.good)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_128, [
                            _createTextVNode("추천 "),
                            _createElementVNode("b", null, _toDisplayString(_ctx.satBuckets.good), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "btn-csv",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.downloadCsv && _ctx.downloadCsv(...args)))
                      }, "CSV")
                    ]),
                    _createElementVNode("div", _hoisted_129, [
                      (_ctx.scope === 'direct')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.searchedKeyword), 1),
                            _createTextVNode("를 그대로 품은 키워드만 보고 있습니다. 글감을 좁힐 때 쓰세요. 주변 주제까지 넓히려면 위에서 "),
                            _hoisted_130,
                            _createTextVNode("를 누르세요. ")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" 검색광고의 연관 키워드는 "),
                            _hoisted_131,
                            _createTextVNode("이 아니라 "),
                            _hoisted_132,
                            _createTextVNode("입니다. 그래서 「라이코펜」에 「델몬트」처럼 글자가 하나도 안 겹치는 것이 섞입니다(같은 업종 광고주가 함께 구매해서). "),
                            _hoisted_133,
                            _createTextVNode("을 누르면 좁혀서 볼 수 있습니다. ")
                          ], 64))
                    ]),
                    (!_ctx.result.docCountAvailable)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_134, " 네이버 오픈API 자격증명이 없어 발행량·포화도를 계산하지 못했습니다. "))
                      : (_ctx.result.docCountFailed > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_135, _toDisplayString(_ctx.result.docCountFailed) + "개 키워드는 네이버 호출 제한으로 발행량을 가져오지 못했습니다. ", 1))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_136, [
                      _createElementVNode("table", _hoisted_137, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _hoisted_138,
                            _createElementVNode("th", {
                              class: "sortable",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sortBy('totalVolume')))
                            }, [
                              _createTextVNode("검색량"),
                              (_ctx.sortKey==='totalVolume')
                                ? (_openBlock(), _createElementBlock("i", _hoisted_139, _toDisplayString(_ctx.sortAsc?"▲":"▼"), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_140,
                            _hoisted_141,
                            _createElementVNode("th", {
                              class: "sortable",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sortBy('docCount')))
                            }, [
                              _createTextVNode("발행량"),
                              (_ctx.sortKey==='docCount')
                                ? (_openBlock(), _createElementBlock("i", _hoisted_142, _toDisplayString(_ctx.sortAsc?"▲":"▼"), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("th", {
                              class: "sortable",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sortBy('saturation')))
                            }, [
                              _createTextVNode("포화도"),
                              (_ctx.sortKey==='saturation')
                                ? (_openBlock(), _createElementBlock("i", _hoisted_143, _toDisplayString(_ctx.sortAsc?"▲":"▼"), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_144
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedRows, (row) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: row.keyword
                            }, [
                              _createElementVNode("td", _hoisted_145, [
                                _createElementVNode("a", {
                                  href: "#",
                                  onClick: _withModifiers(($event: any) => (_ctx.searchKeyword(row.keyword)), ["prevent"])
                                }, _toDisplayString(row.keyword), 9, _hoisted_146),
                                (_ctx.scope !== 'direct' && row.relevance === 'direct')
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_147))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", _hoisted_148, _toDisplayString(row.totalVolume.toLocaleString()), 1),
                              _createElementVNode("td", _hoisted_149, _toDisplayString(row.pcVolume.toLocaleString()), 1),
                              _createElementVNode("td", _hoisted_150, _toDisplayString(row.mobileVolume.toLocaleString()), 1),
                              _createElementVNode("td", _hoisted_151, _toDisplayString(_ctx.fmt(row.docCount)), 1),
                              _createElementVNode("td", _hoisted_152, [
                                (row.saturation === null)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_153, "-"))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: _normalizeClass(["saturation", _ctx.saturationClass(row.saturation)])
                                    }, _toDisplayString(row.saturation.toFixed(2)), 3))
                              ]),
                              _createElementVNode("td", _hoisted_154, _toDisplayString(row.competition || "-"), 1)
                            ]))
                          }), 128)),
                          (_ctx.sortedRows.length === 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_155, _hoisted_157))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_158, [
                      _createTextVNode(" 키워드를 누르면 그 키워드로 다시 분석합니다. "),
                      _createElementVNode("span", _hoisted_159, [
                        _hoisted_160,
                        _createTextVNode("포화도 1 미만 " + _toDisplayString(_ctx.satBuckets.good) + "개", 1)
                      ]),
                      _createElementVNode("span", _hoisted_161, [
                        _hoisted_162,
                        _createTextVNode("1~5 " + _toDisplayString(_ctx.satBuckets.mid) + "개", 1)
                      ]),
                      _createElementVNode("span", _hoisted_163, [
                        _hoisted_164,
                        _createTextVNode("5 이상 " + _toDisplayString(_ctx.satBuckets.bad) + "개", 1)
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.activeTab === 'related']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_165, [
            (_ctx.profileLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_166, "불러오는 중…"))
              : (_ctx.profile && _ctx.profile.topBlogs && _ctx.profile.topBlogs.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_167,
                    _createElementVNode("ul", _hoisted_168, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profile.topBlogs, (b, i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: b.link,
                          class: "blog-item"
                        }, [
                          _createElementVNode("span", _hoisted_169, _toDisplayString(i + 1), 1),
                          _createElementVNode("div", _hoisted_170, [
                            _createElementVNode("a", {
                              class: "bl-title",
                              href: b.link,
                              target: "_blank",
                              rel: "noopener"
                            }, _toDisplayString(b.title), 9, _hoisted_171),
                            _createElementVNode("p", _hoisted_172, _toDisplayString(b.description), 1),
                            _createElementVNode("div", _hoisted_173, [
                              _createElementVNode("span", _hoisted_174, _toDisplayString(b.blogger), 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(["bl-date", { fresh: _ctx.isFresh(b.postDate) }])
                              }, _toDisplayString(b.postDate), 3)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("p", _hoisted_175, _toDisplayString(_ctx.freshnessSummary), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_176, "표시할 블로그 글이 없습니다."))
          ], 512), [
            [_vShow, _ctx.activeTab === 'blogs']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_177, _hoisted_180, 512), [
            [_vShow, _ctx.activeTab === 'section']
          ])
        ], 64))
      : (!_ctx.anyLoading && !_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_181, [
            _createTextVNode(" 키워드를 입력하고 "),
            _hoisted_182,
            _createTextVNode("를 눌러 보세요. ")
          ]))
        : _createCommentVNode("", true)
  ]))
}